export type CaptureKind = "microphone" | "system";

export function captureUnavailableReason(kind: CaptureKind, secure: boolean, devices?: MediaDevices): string | null {
  if (!secure) return "录音和实时采集需要 HTTPS。手机请打开 HTTPS 地址，本机开发可使用 localhost。";
  if (kind === "microphone" && !devices?.getUserMedia) return "当前浏览器无法使用麦克风，请用 Safari 或 Chrome 打开，或选择本地文件。";
  if (kind === "system" && !devices?.getDisplayMedia) return "当前浏览器不支持共享系统音频，请使用麦克风或本地文件。";
  return null;
}

export async function captureMicrophone(devices: MediaDevices): Promise<MediaStream> {
  // Best-effort constraints: retain transients without requiring a particular sample rate or device.
  const stream = await devices.getUserMedia({ video: false,
    audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false } });
  if (!stream.getAudioTracks().some(track => track.readyState === "live")) {
    stream.getTracks().forEach(track => track.stop());
    throw new Error("麦克风没有提供音频，请检查输入设备后重试。");
  }
  return stream;
}

export function captureErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    if (error.name === "NotAllowedError") return "未获得音源权限。请在浏览器的网站设置中允许麦克风或共享音频，然后重试。";
    if (error.name === "NotFoundError") return "没有找到可用输入，请检查麦克风或音频设备。";
    if (error.name === "NotReadableError") return "音源暂时不可用，请关闭占用麦克风的应用后重试。";
    return error.message;
  }
  return "连接音源失败，请重试。";
}

export function createPerformanceAudioContext(): AudioContext {
  const Constructor = window.AudioContext || (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Constructor) throw new Error("当前浏览器不支持 Web Audio，请使用 Safari 或 Chrome。");
  return new Constructor({ latencyHint: "interactive" });
}
